import  
        React, {
        createContext,
        useCallback,
        useContext,
        useState,
        
    }                       from "react";
import  Style               from "components/UI/main.module.scss";
import { BtnCloseAction }   from "components/Buttons/Close/BtnClose";

const SideContentContext        = createContext(null);

export const useSideContent     = () => {
    const context = useContext(SideContentContext);

    if (!context) {
    throw new Error("useSideContent must be used inside SideContentProvider");
}

    return context;
};

export const SideContent        = ({ children }) => {
    const [isOpen,      setIsOpen]      = useState(false);
    const [isSliding,   setIsSliding]   = useState(false);
    const [overlay,     setOverlay]     = useState(true);
    const [content,     setContent]     = useState({    
        Component: null,
        props: {},
        key: null,
    });

    const hideSideContent = useCallback(() => {
        setIsSliding(false);

        setTimeout(() => {
            setIsOpen(false);
            setContent({
                Component: null,
                props: {},
                key: null,
            });
        }, 300);
    }, []);

    const showSideContent = useCallback(({ component: Component, props = {}, overlay = true, key = Date.now() }) => {
        setContent({
            Component,
            props,
            key,
        });

        setOverlay(overlay);
        setIsOpen(true);

        requestAnimationFrame(() => {
            setIsSliding(true);
        });
    }, []);

    const customClass   = [   
        isOpen ? Style.side_content_expanded : Style.side_content_retracted,
        isSliding ? Style.side_content_slide_in : Style.side_content_slide_out,
    ].join(" ");

    const customStyle   = overlay && isOpen ? { width: "100%", background: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(2px)", } : {} ;

    const Component     = content.Component;

    return (
        <SideContentContext.Provider value={{ showSideContent, hideSideContent }}>
            {children}

            {Component && (
                <div style={customStyle} className={Style.side_content}>
                    <div className={customClass}>
                        <div className={Style.row}>
                            <div className={Style.col}>
                            <div className={[Style.text_end, Style.p_3].join(" ")}>
                                <BtnCloseAction click_action={hideSideContent} />
                            </div>
                            </div>
                        </div>

                        <div
                            style={{ height: "100vh" }}
                            className={Style.overflow_y_auto}
                        >
                            <div className={Style.mb_5}>
                                <Component key={content.key} {...content.props} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </SideContentContext.Provider>
    );
};